const searchClient = algoliasearch('NJ2NNTJM63', 'd70b4e74c1c323be62e4fe7229e30a8e');
var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
var lazyImageObserver;

const search = instantsearch({
    indexName: algolia_index_name,
    routing: true,
    searchClient
});

var filter_string = ' (inventory_available:true OR meta.custom.show_oos:true) ';
if(algolia_current_handle && algolia_current_handle != 'all'){
    filter_string += ' AND ( collections:' + algolia_current_handle;  

    /*if(algolia_child_handle){
      var child = algolia_child_handle.split(",")  
        if(algolia_algolia_path_en.split(" > ").length <= 2){
          for (let index = 0; index < child.length; index++) {
            if(child[index]){
              filter_string += ' OR collections:' + (child[index].replace(/\s+/g, '-').toLowerCase());
            }
          }
      }
    }*/
     
    filter_string += ' ) ';
}

function cleanDesc(html){
    var div = document.createElement("div");
    div.innerHTML = html;
    var text = div.textContent || div.innerText || "";

    return text.substr(0,255)
}

function numberFormat(number){
    var point = algolia_hide_decimal ? 0 : 2;
    return parseFloat(number).toFixed(point).toLocaleString('en-US')
}

if (algolia_current_handle == 'deals') filter_string += ' AND compare_at_price > 0';

search.addWidget(
    instantsearch.widgets.configure({
        filters: filter_string
    })
);

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


var algolia_search = getParameterByName('q');
if (algolia_search && algolia_search !== '') {
    const renderSearchBox = (renderOptions,isFirstRender)=>{
        const {query, refine} = renderOptions;
        const container = document.querySelector('#q');
        if (isFirstRender) {
            const input = document.createElement('input');
            input.addEventListener('input', (event)=>{
                refine(event.target.value);
            }
            );
            container.appendChild(input);
            if (query === '') {
                refine(algolia_search);
            }
        }
        container.querySelector('input').value = query;
    }
    
    const customSearchBox = instantsearch.connectors.connectSearchBox(renderSearchBox);
    search.addWidgets([customSearchBox({
        container: document.querySelector('#q'),
    })]);

    $(".serach-box input, .search-bar__input").val(algolia_search)
}

search.addWidgets([
    instantsearch.widgets.hits({
        container: '#hits',
        cssClasses: {
          item: 'grid__item grid__item--collection-template small--one-half  medium-up--one-quarter',
        },
        templates: {
            item: function(data) {
                var url_prefix = algolia_lang_prefix == 'zh' ? '/zh' : '';

                var product = '';
                product += '<div class="grid-view-item product-card" itemtype="https://schema.org/Product" itemscope>';
                product += '<div class="product-card__image-with-placeholder-wrapper">';
                product += '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="' + url_prefix + '/products/' + data.handle + '"><span class="visually-hidden">' + data.title + '</span></a>';
                product += '</div>';

                product += '<div style="text-align:center;"><a href="' + url_prefix + '/products/' + data.handle + '">';
                if (data.image == null) {
                    product += '<img class="grid-view-item__image" src="https://img.babycentral.com.hk/tr:n-catthumb/image/placeholder.png" alt="No Image">';
                } else {
                    //product += '<img class="grid-view-item__image lazy" src="https://img.babycentral.com.hk/tr:n-catthumblow/image/img_loader.jpg" srcset="" data-src="' + data.product_image + '" alt="' + data.handle + '">';
                    var image = data.product_image;
                    var file = image.substr( (image.lastIndexOf('.')) );
                    var prefix = image.replace(file,"");

                    var name = data.title;
                    if (data.meta.custom && typeof data.meta.custom['short_name'] !== "undefined" && data.meta.custom['short_name'] !== '') {
                        name = data.meta.custom['short_name'];
                    }
                    if(algolia_lang_prefix == 'zh' && data.meta.custom && typeof data.meta.custom['tc_name'] !== "undefined" && data.meta.custom['tc_name'] !== ''){
                        name = data.meta.custom['tc_name'];
                    }

                    var img_alt = name;

                    if(data.vendor){
                        img_alt =  data.vendor + ' ' + img_alt;
                    }
                    
                    /*var sizes = [300, 800];
                    var srcset = [];
                    $.each(sizes,function(i,j) {
                        srcset.push(prefix + "_" + j + "x" + file + " " + j+"w")
                    })*/
                   // product += `<img class="grid-view-item__image lazy" data-widths="[300, 800]"  width="300px" height="300px" data-aspectratio="1" data-sizes="auto" srcset="${srcset.join(", ")}" alt="${data.handle}">`;
                   var image250 = prefix + "_250x" + file;
                    var image300 = prefix + "_300x" + file;
                  var image180 = prefix + "_180x" + file;
                  product += `<picture>
                              <source media="(max-width: 746px)" srcset="` + image180 + `" width="180px" height="180px" />
                              <source media="(max-width: 1480px)" srcset="` + image250 + `" width="250px" height="250px" />
                              <img class="lazy" src="https://img.babycentral.com.hk/tr:n-catthumb300/image/img_loader.jpg" data-src="` + image300 + `" alt="` + img_alt + `" width="300px" height="300px"/>
                            </picture>`
                }
                product += '</a></div>';

                var shipping = '';

                if (data.inventory_available==false) {
                  shipping = '<div class="shipping-grey">Back Soon</div>'; 
                } else if(data.meta.custom && typeof data.meta.custom['stock'] !== "undefined" && data.meta.custom['stock'] !== ''){
                   if (data.meta.custom['stock'][algolia_internal_warehouse] > 0) {
                     shipping = '<div class="readytoship"><i class="fas fa-rocket"></i>&nbsp;Ready to Ship</div>';
                   } else if (data.meta.custom['stock'][algolia_threepl_warehouse] > 0) {
                       var end_threepl_days = Number(algolia_threepl_days) + 2;
                       shipping = '<div class="shipping-grey"><i class="fas fa-truck"></i>&nbsp;' + algolia_threepl_days + '-' + end_threepl_days + ' Days</div>'; 
                   } else if (data.meta.custom['stock']['DROPSHIP'] > 0) {
                     var end_dropship_days = Number(algolia_dropship_days) + 2;
                     shipping = '<div class="shipping-grey"><i class="fas fa-truck"></i>&nbsp;' + algolia_dropship_days + '-' + end_dropship_days + ' Days</div>'; 
                   } else if (data.meta.custom['stock']['PREORDER'] > 0) {
                     var end_preorder_days = Number(algolia_preorder_days) + 2;
                     shipping = '<div class="shipping-grey"><i class="fas fa-truck"></i>&nbsp;' + algolia_preorder_days + '-' + end_preorder_days + ' Days</div>'; 
                   }
                }
               product += shipping;


                

                var vendor_link = data.vendor;
                if(data.meta.custom && typeof data.meta.custom['vendor_handle'] !== "undefined" && data.meta.custom['vendor_handle'] !== ''){
                    vendor_link =  '<a href="' + url_prefix + '/collections/' + data.meta.custom['vendor_handle'] + '">' + data.vendor + '</a>';
                }
                
                product += '<div class="price__vendor price__vendor--listing"><span class="visually-hidden">Vendor</span>' + vendor_link + '</div>';
                product += '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true"><a href="' + url_prefix + '/products/' + data.handle + '">' + name + '</a></div>';


               
                var discount = parseInt(data.meta.custom['discount']);
                var price = '';
                /*var discount_percentage = Math.abs((data.price  * (1-discount )).toFixed();*/

                /*if (discount > 0) {
                    price += '<dl class="price price--listing price--on-sale ">';
                    var item_price = data.price * (1-discount/100);
                    var original_price = data.price;
                } else {
                    price += '<dl class="price price--listing ">';
                    var item_price = data.price;
                    var original_price = data.price;
                }*/
                if (data.compare_at_price > 0 && !discount){
                  discount = parseInt(Math.round(((numberFormat(data.compare_at_price) - numberFormat(data.price)) / numberFormat(data.compare_at_price))*100))
                }
                if (discount > 0) {
                    price += '<dl class="price price--listing price--on-sale ">';
                    if (data.compare_at_price > 0){
                      var item_price = data.price;
                      var original_price = data.compare_at_price;
                    }else{
                      var item_price = data.price * (1-discount/100);
                      var original_price = data.price;
                    }
                } else {
                    price += '<dl class="price price--listing ">';
                    /*var item_price = data.price;*/
                    var item_price = data.price;
                    var original_price = data.price;
                }

                price += '<div class="price__sale">';
                price += '<dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt>';
                price += '<dd><span class="price-item price-item--sale"><span class="price-discount-badge">'+ discount +'% OFF</span>'+ algolia_currency_code +" "+ numberFormat(item_price) + '</span></dd>';
                price += '<div class="price__compare">';
                price += '<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
                price += '<dd><s class="price-item price-item--regular">'+ algolia_currency_code + " " + numberFormat(original_price) + '</s></dd>';
                price += '</div>';
                price += '</div>';
                price += '<div class="price__regular">';
                price += '<dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt>';
                price += '<dd><span class="price-item price-item--regular">'+ algolia_currency_code +" "+ numberFormat(original_price) + '</span></dd>';

                /*if (data.compare_at_price == 0 && data.tags.includes("BFF")) {
                    price += '<div class="price__bff">-10% for BFFs</div>';
                }*/
                price += '</div>';

                price += '</dl>';

                var colors_div = '';
                if (data.meta.custom && typeof data.meta.custom['colour_options'] == "object" && data.meta.custom['colour_options'] && data.meta.custom['colour_options'].length > 1) {
                  colors_div += '<div class="color-group">';
                  for (var i = 0; i < data.meta.custom['colour_options'].length; i++) {
                      if(i >= 4){
                        colors_div = colors_div + '<div class="product-color-text" style="background-color:#fff">'+ (data.meta.custom['colour_options'].length-i) +' more colours</div>';
                        break;
                      }
                      colors_div = colors_div + '<div class="product-color" style="background-color: ' + data.meta.custom['colour_options'][i] + '"></div>';
                  }
                  colors_div = colors_div + '</div>';
                }

                var review = '';
                if (data.meta.custom && typeof data.meta.custom['reviews'] == "object" && typeof data.meta.custom['reviews']['quantity'] != 'undefined') {
                    var r_quantity = data.meta.custom['reviews']['quantity'];
                    var r_rating = data.meta.custom['reviews']['rating'];
                    review = `<div class="star-rating-container"><div class="star-rating" data-stars="${r_rating}">
                      <i></i><i></i><i></i><i></i><i></i>
                    </div>
                    <div class='review-counts'>${r_quantity} review(s)</div></div>`
                }

                var special_offers = '';
                if (data.meta.custom && typeof data.meta.custom['special_offers'] == "object" && typeof data.meta.custom['special_offers'][0]['description']['en']['collection_page'] != 'undefined') {
              
                    special_offers = '<div class="combo-offer-text">' + data.meta.custom['special_offers'][0]['description']['en']['collection_page'] + '</div>';
                }
                

                 if (data.variants_count > 1)
                {
                  if (algolia_lang_prefix == 'zh') {
                      var add_to_cart = '<a class="btn" href="' + url_prefix + '/products/' + data.handle + '">選取選項</a>' ;
                  } else if (algolia_lang_prefix == 'id') {
                      var add_to_cart = '<a class="btn" href="' + url_prefix + '/products/' + data.handle + '">Opsi Pilihan</a>' ;
                  } else {
                      var add_to_cart = '<a class="btn" href="' + url_prefix + '/products/' + data.handle + '">Select Options</a>' ;
                  }
                } else if (data.inventory_available==true) {
                  var add_to_cart = '<form method="post" action="/cart/add" id="product_form_' + data.objectID + '" accept-charset="UTF-8" class="product-form product-form-product-template" enctype="multipart/form-data" novalidate="novalidate" data-product-form="">';
                  add_to_cart += '<input type="hidden" name="form_type" value="product">';
                  add_to_cart += '<input type="hidden" name="utf8" value="✓">';
                  add_to_cart += '<input type="hidden" name="id" value="' + data.objectID + '">';
                  if (algolia_lang_prefix == 'zh') {
                      add_to_cart += '<button type="submit" name="add" aria-label="Add to cart" class="btn" aria-haspopup="dialog" data-add-to-cart=""><span data-add-to-cart-text="">加到購物車</span></button>';
                  } else if (algolia_lang_prefix == 'id') {
                      add_to_cart += '<button type="submit" name="add" aria-label="Add to cart" class="btn" aria-haspopup="dialog" data-add-to-cart=""><span data-add-to-cart-text="">Tambahkan ke keranjang</span></button>';
                  } else {
                      add_to_cart += '<button type="submit" name="add" aria-label="Add to cart" class="btn" aria-haspopup="dialog" data-add-to-cart=""><span data-add-to-cart-text="">Add to cart</span></button>';
                  }
                  add_to_cart += '</form>';
                } else {
                   var add_to_cart = "";
                }

                product += price + colors_div + review + add_to_cart;
                

                product += `
                  <meta itemprop="name" content="${name}" />
                  <link itemprop="image" href="${data.image}" />
                  <div itemprop="brand" itemtype="https://schema.org/Brand" itemscope>
                    <meta itemprop="name" content="${data.vendor}" />
                  </div>
                  <meta itemprop="description" content="${cleanDesc(data.body_html_safe)}" />
                `;

                /*var discount_price = data.price;
                if(data.compare_at_price > 0){
                    discount_price = data.price;
                } else if (data.compare_at_price == 0 && data.tags.includes("BFF")) {
                    discount_price = ((data.price-(data.price * 10) / 100)).toFixed(2);
                }*/

                if(discount > 0){
                    product += `
                        <div itemprop="offers" itemtype="https://schema.org/Offer" itemscope="">
                            <link itemprop="url" href="${url_prefix}/products/${data.handle}">
                            <meta itemprop="itemCondition" content="https://schema.org/NewCondition">
                            <meta itemprop="priceCurrency" content="${algolia_currency_code}">
                            <meta itemprop="price" content="${item_price}">
                            <link itemprop="availability" href="http://schema.org/InStock">
                            <meta itemprop="priceValidUntil" content="2030-01-01" />
                        </div>
                    `;
                }

                product += special_offers;
                return product;
            }
        },
    })
]);

search.addWidgets([
    instantsearch.widgets.refinementList({
        container: '#manufacturers',
        attribute: 'vendor',
        operator: 'or',
        limit: 10,
        showMore: true,
        showMoreLimit: 20,
        searchable: true,
        searchablePlaceholder: 'Search brands',
        sortBy: ['name:asc'],
        templates: {
            //item: facetTemplateCheckbox,
            header: '<div class="facet-title" onclick="this.classList.toggle(\'active\')">Brands<div class="arrow"></div></div">'
        }
    }),

    instantsearch.widgets.configure({
        hitsPerPage: 60
    }),
]);

search.addWidget(
    instantsearch.widgets.rangeSlider({
        container: '#price-refinement',
        attribute: 'price',
        templates: {
            header: '<div class="facet-title" >Price<div class="arrow"></div></div">'
        },
        collapsible: {
            collapsible: true,
            collapsed: true
        },
        tooltips: {
            format: function (rawValue) {
                return algolia_currency_code + Math.round(rawValue).toLocaleString();
            }
        },
    })
);

/*search.addWidgets([
    instantsearch.widgets.refinementList({
        container: '#age',
        attribute: 'meta.custom.age_filters',
        operator: 'or',
        limit: 10,
        showMore: true,
        showMoreLimit: 20,
        searchable: false,
        searchablePlaceholder: 'Search Age',
        sortBy: ['name:asc'],
        templates: {
            //item: facetTemplateCheckbox,
            header: '<div class="facet-title" onclick="this.classList.toggle(\'active\')">Age<div class="arrow"></div></div">'
        }
    }),

    instantsearch.widgets.configure({
        hitsPerPage: 50
    }),
]);*/

const widgetAge = instantsearch.widgets.panel({
    hidden: function(options) {
        $("#age").parents(".facet-wrapper").show();
        if (options.items.length <= 0) {
            $("#age").parents(".facet-wrapper").hide();
        }
    },
})(instantsearch.widgets.refinementList);

search.addWidget(widgetAge({
  container: '#age',
  attribute: 'meta.custom.age_filters',
  operator: 'or',
  sortBy(a, b) {
      var asplit = a.name.split(" ");
      var bsplit = b.name.split(" ");

      var aint = parseInt(asplit[0]);
      var bint = parseInt(bsplit[0]);

      var aden = asplit[3];
      var bden = bsplit[3];

      if (aden == "years" && bden == "months") {
          return 1;
      }

      if (aden == "months" && bden == "years") return -1;

      if (aden == bden) {
          if (aint > bint)
              return 1;
          else
              return -1;
      }
  },
  limit: 10,
  showMore: true,
  collapsible: {
      collapsible: true,
      collapsed: false
  },
  autoHideContainer: true,
  templates: {
      //item: facetTemplateCheckbox,
      header: '<div class="facet-title" onclick="this.classList.toggle(\'active\')">Age<div class="arrow"></div></div">'
  }
}));


const widgetReview = instantsearch.widgets.panel({
    hidden: function(options) {
        
    },
})(instantsearch.widgets.refinementList);

search.addWidget(widgetReview({
  container: '#rating_filter',
  attribute: 'meta.custom.reviews.rating',
  operator: 'or',
  
  limit: 10,
  showMore: true,
  collapsible: {
      collapsible: true,
      collapsed: false
  },
  autoHideContainer: true,
  transformItems(items) {
    var _items = [];
    for(var i=5; i>=1;i--){
      let obj = items.find(o => o.label === i.toString());

      if(obj){
        _items.push(obj)
      } else {
        _items.push({
          count : 0,
          highlighted : i.toString(),
          isRefined : false,
          label: i.toString(),
          value: i,
        })
      }
    }
    return _items
  },
  templates: {
    item(item, { html }) {
      const { url, label, count, isRefined } = item;
      var star = '';
      for(var j=1;j<=parseInt(label);j++){
        star += `<svg class="ais-RatingMenu-starIcon ais-RatingMenu-starIcon--full" aria-hidden="true" width="24" height="24"><use href="#ais-RatingMenu-starSymbol"></use></svg>`;
      }
      for(var k=j;k<=5;k++){
        star += `<svg class="ais-RatingMenu-starIcon ais-RatingMenu-starIcon--empty" aria-hidden="true" width="24" height="24"><use href="#ais-RatingMenu-starEmptySymbol"></use></svg>`;
      }
      return `
        <div class="rating-filter">
          <input id="rating-${label}" type="checkbox" ${isRefined ? "checked" : ""}>
          <label for="rating-${label}" class='rating'>${star}</label>
          <span>${count}</span>
        </div>
      `;
    },
  },
}));

const widgetVIPDiscount = instantsearch.widgets.panel({
      hidden: function(options) {
          return options.value.count === null;
      },
})(instantsearch.widgets.toggleRefinement);

/*search.addWidget(widgetVIPDiscount({
    container: '#has-vip-discount',
    autoHideContainer: true,
    attribute: 'tags',
    label: ' BFF Discount ({{ count }})',
    on: 'BFF',
    templates: {
        labelText: 'BFF Discount ({{ count }})'
    }
}));*/

search.addWidget(
    instantsearch.widgets.sortBy({
        container: '#sort-by-container',
        items: [
          { value: (window.algolia_prefix +'products'), label: algolia_lang_prefix == 'zh' ? '最相關的' : (algolia_lang_prefix == 'id' ? 'Paling Favorit' :  'Most relevant') },
          { value: (window.algolia_prefix +'products_price_high_to_low'), label: algolia_lang_prefix == 'zh' ? '價錢（高至低)' : (algolia_lang_prefix == 'id' ? 'Harga Tertinggi' :  'Highest price') },
          { value: (window.algolia_prefix +'products_price_low_to_high'), label: algolia_lang_prefix == 'zh' ? '價錢（低至高)' : (algolia_lang_prefix == 'id' ? 'Harga Terendah' :  'Lowest price') },
        ]
    })
);

const renderPagination = (renderOptions, isFirstRender) => {
    const {
        pages,
        currentRefinement,
        nbPages,
        isFirstPage,
        isLastPage,
        refine,
        createURL,
    } = renderOptions;

    if (renderOptions.nbHits > 0) {
        var startIndex = (renderOptions.currentRefinement * 60) + 1
        var endIndex = Math.min((renderOptions.currentRefinement * 60) + 60, renderOptions.nbHits);
        if (algolia_lang_prefix == 'zh') {
            var paginationText = `顯示 ${renderOptions.nbHits}&nbsp;個產品中的 ${(startIndex)} - ${endIndex}&nbsp;個`;
        } else if (algolia_lang_prefix == 'id') {
            var paginationText = `Tampilkan ${(startIndex)} - ${endIndex}&nbsp;dari ${renderOptions.nbHits}&nbsp; produk`;
        } else {
            var paginationText = `Showing ${(startIndex)} - ${endIndex}&nbsp;of ${renderOptions.nbHits}&nbsp; products`;
        }
        $(".pagination-text").html(paginationText);
    } else {
        $(".pagination-text").html('');
    }



    const container = document.querySelector('#paginationnew');

    container.innerHTML = `
          <div>
            <div class="custom-pagin ais-Pagination">
                <ul class="ais-Pagination-list">
                  ${
                    !isFirstPage
                      ? `
                        <li class="ais-Pagination-item ais-Pagination-item--firstPage">
                        <a
                          class="ais-Pagination-link"
                            href="${createURL(0)}"
                            data-value="${0}"
                          >
                            «
                          </a>
                        </li>
                        <li class="ais-Pagination-item ais-Pagination-item--previousPage">
                          <a
                          class="ais-Pagination-link"
                            href="${createURL(currentRefinement - 1)}"
                            data-value="${currentRefinement - 1}"
                          >
                            ‹
                          </a>
                        </li>
                        `
                      : `
                      <li class="ais-Pagination-item ais-Pagination-item--firstPage ais-Pagination-item--disabled"><span class="ais-Pagination-link">«</span></li>
                      <li class="ais-Pagination-item ais-Pagination-item--previousPage ais-Pagination-item--disabled"><span class="ais-Pagination-link">‹</span></li>
                      `
                  }
                  ${pages
                    .map(
                      page => `
                        <li class="ais-Pagination-item ais-Pagination-item--page">
                          <a
                            class="ais-Pagination-link"
                            href="${createURL(page)}"
                            data-value="${page}"
                            style="font-weight: ${currentRefinement === page ? 'bold' : ''}"
                          >
                            ${page + 1}
                          </a>
                        </li>
                      `
                    )
                    .join('')}
                    ${
                      !isLastPage
                        ? `
                          <li class="ais-Pagination-item ais-Pagination-item--nextPage">
                            <a
                                class="ais-Pagination-link"
                              href="${createURL(currentRefinement + 1)}"
                              data-value="${currentRefinement + 1}"
                            >
                              ›
                            </a>
                          </li>
                          <li class="ais-Pagination-item ais-Pagination-item--lastPage">
                            <a
                                class="ais-Pagination-link"
                              href="${createURL(nbPages - 1)}"
                              data-value="${nbPages - 1}"
                            >
                              »
                            </a>
                          </li>
                          `
                        : `
                        <li class="ais-Pagination-item ais-Pagination-item--nextPage ais-Pagination-item--disabled"><span class="ais-Pagination-link">›</span></li>
                        <li class="ais-Pagination-item ais-Pagination-item--lastPage ais-Pagination-item--disabled"><span class="ais-Pagination-link">»</span></li>
                        `
                    }
                </ul>
            </div>
        </div>

        `;
    [...container.querySelectorAll('a')].forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();
            var body = $("html, body");
            body.stop().animate({
                scrollTop: ($("#hits").offset().top - 100)
            }, 500, 'swing', function() {});
            refine(event.currentTarget.dataset.value);
        });
    });
};


const customPagination = instantsearch.connectors.connectPagination(
    renderPagination
);

search.addWidgets([
    customPagination({
        container: document.querySelector('#paginationnew'),
    })
]);

var isFirst = 0;
search.on('render', function() {
  if(lazyImageObserver){
    var _lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    _lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });
  }
  try {
    $('.star-rating').print_stars();  
  } catch (error) {}

  if(isFirst > 2){
    var body = $("html, body");
    body.stop().animate({
        scrollTop: ($("#hits").offset().top - 100)
    }, 500, 'swing', function() {});
  }
  isFirst++;
});


search.addWidget(instantsearch.widgets.currentRefinements({
  container: '#current-refined-values',
  clearAll: 'after',
  clearsQuery: true,
  includedAttributes: ['vendor', 'price','meta.custom.age_filters','meta.custom.reviews.rating'],
  attributes: [{
      name: 'vendor',
      label: ''
  }, {
      name: 'price',
      label: ''
  }, {
      name: 'baby_age_filters',
      label: ''
  }, {
      name: 'kids_age_filters',
      label: ''
  }, {
      name: 'meta.custom.age_filters',
      label: 'Age'
  }, ],
  onlyListedAttributes: true,
  cssClasses: {
      count: 'filter-count',
      item: 'filter-item-clear',
      list: 'filter-list',
      clearAll: 'filter-clear-all'
  },
  templates: {
      item: '{{name}} ✖'
  },
}));
const widgetclearRefinements = instantsearch.widgets.panel({
  hidden: function(options) {
      $("#clear-refinements").show();
      if (!options.hasRefinements) {
          $("#clear-refinements").hide();
      }
  },
})(instantsearch.widgets.clearRefinements);
search.addWidget(widgetclearRefinements({
  container: '#clear-refinements',
  includedAttributes: ['vendor', 'price','tags','meta.custom.age_filters','meta.custom.reviews.rating'],
  templates: {
      resetLabel: 'Clear all',
  },
}));

search.start();



  if ("IntersectionObserver" in window) {
    lazyImageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          //lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });

    lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
    });
  } else {
    // Possibly fall back to event handlers here
  }


    var _getVariantOptionList = function(variantOptions) {
      var variantOptionListHTML = '';
  
      variantOptions.forEach(function(variantOption) {
          variantOptionListHTML =
              variantOptionListHTML +
              '<li class="product-details__item product-details__item--variant-option">' +
              variantOption.name +
              ': ' +
              variantOption.value +
              '</li>';
      });
  
      return variantOptionListHTML;
    }
  
  var _getSellingPlanHTML = function(selling_plan_name) {
      var sellingPlanHTML =
          '<li class="product-details__item product-details__item--property">' +
          selling_plan_name +
          '</li>';
  
      return sellingPlanHTML;
  }
  
  var _getPropertyList = function(properties) {
      var propertiesArray = properties !== null ? Object.entries(properties) : [];
  
      var filteredPropertiesArray = propertiesArray.filter(function(property) {
          if (property[0].charAt(0) === '_' || property[1].length === 0) {
              return false;
          } else {
              return true;
          }
      })

      return filteredPropertiesArray.map(
          function(property) {
              var propertyElement = this.itemPropertyTemplate.cloneNode(true);
  
              propertyElement.querySelector(
                  selectors.cartItemPropertyName
              ).textContent = property[0] + ': ';
  
              if (property[0].indexOf('/uploads/') === -1) {
                  propertyElement.querySelector(
                      selectors.cartItemPropertyValue
                  ).textContent = property[1];
              } else {
                  propertyElement.querySelector(
                          selectors.cartItemPropertyValue
                      ).innerHTML =
                      '<a href="' +
                      property[1] +
                      '"> ' +
                      property[1].split('/').pop() +
                      '</a>';
              }
  
              propertyElement.classList.remove(classes.hide);
  
              return propertyElement;
          }.bind(this)
      );
  }

  var _hideCartPopup = function() {
      var selectors = {
          cartPopup: '[data-cart-popup]',
          cartPopupImage: '[data-cart-popup-image]',
          cartPopupWrapper: '[data-cart-popup-wrapper]',
          cartPopupImagePlaceholder: '[data-image-loading-animation]',
      };

      var cartPopup = document.querySelector(selectors.cartPopup);
      var cartPopupWrapper = document.querySelector(selectors.cartPopupWrapper);
      var cartPopupImagePlaceholder = document.querySelector(selectors.cartPopupImagePlaceholder);

      theme.Helpers.prepareTransition(cartPopupWrapper);
      cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');

      var cartPopupImage = document.querySelector(selectors.cartPopupImage);
      if (cartPopupImage) {
          cartPopupImage.remove();
      }

      cartPopupImagePlaceholder.setAttribute('data-image-loading-animation', '');

      slate.a11y.removeTrapFocus({
          container: cartPopupWrapper,
          namespace: 'cartPopupFocus'
      });
  }

  $("#hits").delegate("[data-product-form]", "submit", function(evt) {
      var form = $(this);
      evt.preventDefault();

      $(form).find('button[type=submit]').addClass("btn-loading");
  
      fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'X-Requested-With': 'XMLHttpRequest'
          },
          body: theme.Helpers.serialize(form[0])
      })
      .then(function(response) {
        $(form).find('button[type=submit]').removeClass("btn-loading");
        return response.json();
      })
      .then(function(item) {
          if (item.status && item.status !== 200) {
            $(form).find('.add-cart-error').remove()
            var newError = document.createElement('div');
            newError.innerHTML = item.description;
            newError.className = "add-cart-error"
            newError.onclick = function () {
                newError.remove()
            };
              
            $(form).find('button[type=submit]').after(newError)

            //window.location.href = $(form).parents(".ais-Hits-item").find(".product-name a").attr("href")
          } else {
        
            var quantity = item.quantity;
            CartTrackingKlaviyo(item)
  
            var selling_plan_name = item.selling_plan_allocation ?
                item.selling_plan_allocation.selling_plan.name :
                null;
  
            var selectors = {
                cartPopup: '[data-cart-popup]',
                cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
                cartPopupClose: '[data-cart-popup-close]',
                cartPopupDismiss: '[data-cart-popup-dismiss]',
                cartPopupImage: '[data-cart-popup-image]',
                cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
                cartPopupImagePlaceholder: '[data-image-loading-animation]',
                cartPopupProductDetails: '[data-cart-popup-product-details]',
                cartPopupQuantity: '[data-cart-popup-quantity]',
                cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
                cartPopupTitle: '[data-cart-popup-title]',
                cartPopupWrapper: '[data-cart-popup-wrapper]',
                cartCountBubble: '[data-cart-count-bubble]',
                cartCount: '[data-cart-count]',
            };
  
            var cartPopup = document.querySelector(selectors.cartPopup);
            var cartPopupWrapper = document.querySelector(selectors.cartPopupWrapper);
            var cartPopupTitle = document.querySelector(selectors.cartPopupTitle);
            var cartPopupQuantity = document.querySelector(selectors.cartPopupQuantity);
            var cartPopupQuantityLabel = document.querySelector(selectors.cartPopupQuantityLabel);
            var cartPopupClose = document.querySelector(selectors.cartPopupClose);
            var cartPopupDismiss = document.querySelector(selectors.cartPopupDismiss);
            var cartPopupImagePlaceholder = document.querySelector(selectors.cartPopupImagePlaceholder);
  
  
            cartPopupTitle.textContent = item.product_title;
            cartPopupQuantity.textContent = quantity;
            cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
                '[count]',
                quantity
            );
  
            var cartPopupImageWrapper = document.querySelector(selectors.cartPopupImageWrapper);
  
            if (item.featured_image.url === null) {
                cartPopupImageWrapper.classList.add('hide');
                return;
            }
  
            if (item.featured_image.url) {
                cartPopupImageWrapper.classList.remove('hide');
                var sizedImageUrl = theme.Images.getSizedImageUrl(item.featured_image.url, '200x');
                var image = document.createElement('img');
                image.src = sizedImageUrl;
                image.alt = item.featured_image.alt;
                image.classList.add('cart-popup-item__image');
                image.setAttribute('data-cart-popup-image', '');
  
                image.onload = function() {
                    $(".cart-popup-item__image").remove();
                    cartPopupImagePlaceholder.removeAttribute(
                        'data-image-loading-animation'
                    );
                    cartPopupImageWrapper.append(image);
                }.bind(this);
            }
  
  
            var cartPopupProductDetails = document.querySelector(selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';
  
            if (!item.product_has_only_default_variant) {
                variantPropertiesHTML = variantPropertiesHTML + _getVariantOptionList(item.options_with_values);
            }
  
            if (selling_plan_name) {
                variantPropertiesHTML = variantPropertiesHTML + _getSellingPlanHTML(selling_plan_name);
            }
  
            if (item.properties !== null && Object.keys(item.properties).length !== 0) {
                variantPropertiesHTML = variantPropertiesHTML + _getPropertyList(item.properties);
            }
  
            if (variantPropertiesHTML.length === 0) {
                cartPopupProductDetails.innerHTML = '';
                cartPopupProductDetails.setAttribute('hidden', '');
            } else {
                cartPopupProductDetails.innerHTML = variantPropertiesHTML;
                cartPopupProductDetails.removeAttribute('hidden');
            }
  
            cartPopupClose.addEventListener('click', _hideCartPopup);
  
            fetch('/cart.js', { credentials: 'same-origin' })
              .then(function(response) {
                  return response.json();
              })
              .then(function(cart) {
  
                  var cartPopupCartQuantity = document.querySelector(selectors.cartPopupCartQuantity);
                  var ariaLabel;
  
                  if (cart.item_count === 1) {
                      ariaLabel = theme.strings.oneCartCount;
                  } else if (cart.item_count > 1) {
                      ariaLabel = theme.strings.otherCartCount.replace('[count]', cart.item_count);
                  }
  
                  cartPopupCartQuantity.textContent = cart.item_count;
                  cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
  
                  var cartCountBubble = document.querySelector(selectors.cartCountBubble);
                  var cartCount = document.querySelector(selectors.cartCount);
  
                  cartCountBubble.classList.remove('hide');
                  cartCount.textContent = cart.item_count;
  
                  theme.Helpers.prepareTransition(cartPopupWrapper);
  
                  cartPopupWrapper.classList.remove('cart-popup-wrapper--hidden');
                  slate.a11y.trapFocus({
                      container: cartPopupWrapper,
                      elementToFocus: cartPopup,
                      namespace: 'cartPopupFocus'
                  });
              })
              .catch(function(error) {
                  console.log(error);
              });
        }
    });
})
